import React, { memo } from 'react'

interface Props {}

const CommonLoading: React.FC<Props> = memo(() => {
  return (
    <div style={{textAlign: "center", padding: 10}}>
      <span className="loading loading-dots loading-lg"></span>
    </div>
  )
})

export default CommonLoading
